import React, { Fragment, useContext, useEffect, useState } from "react";
import { MdSave } from "react-icons/md";
import { useParams } from "react-router-dom";
import { findOne, save } from "../../../../../services/Folder__Service";
import notifyContext from "../../../../Context/notifyContext";
import Loader from "../../../../Loader/Loader";

const FormFolder = ({ initialFolder = null, setReload }) => {
  const notify = useContext(notifyContext);
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [folder, setFolder] = useState({
    id: 0,
    name: "",
    createdBy: null,
    salarie: null,
    date_create: null,
    time_create: null,
    date_update: null,
    time_update: null,
  });
  const paramsRoute = useParams();

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (folder.name === "") {
      display_errors.push({
        message: "Veuillez remplir le nom",
        id_input: "name",
      });
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      setError(null);
      save({ ...folder, salarieId: paramsRoute.id })
        .then(() => {
          setIsSend(false);
          setFolder({
            id: 0,
            name: "",
            createdBy: null,
            salarie: null,
            date_create: null,
            time_create: null,
            date_update: null,
            time_update: null,
          });
          setReload(true);
          notify("Enregistré avec succès", "success");
          // redirect("/client/salarie/" + paramsRoute.id + "/folder/");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setFolder((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  useEffect(() => {
    if (initialFolder) {
      setFolder({ ...initialFolder });
    }
  }, [initialFolder]);
  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);
  return (
    <Fragment>
      <div className={"form-wrapper"}>
        <form className="form" onSubmit={handleSubmit}>
          {error && error !== "" && (
            <div className="form-header">
              <div className="error">{error}</div>
            </div>
          )}

          <div className="form-body">
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Nom :
              </label>
              <input
                name="name"
                id="name"
                className="form-input"
                value={folder.name}
                onChange={handleChange}
                wrap="true"
              />
            </div>
          </div>

          <div className="form-footer">
            <button type="submit" className="btn">
              <MdSave />
              Enregistrer
            </button>
          </div>
        </form>
      </div>

      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </Fragment>
  );
};

export default FormFolder;
